import React from "react";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { InstanceList } from "./List/InstanceList";
import { useInstanceListQuery } from "generated/graphql";
import { useTenantId } from "polyrouter/SelectedTenantProvider";

export const Instances: React.FC = () => {
  const { Content } = Layout;
  const { t } = useTranslation();
  const tenantId = useTenantId();

  // todo move the count and type into its own object

  const { data } = useInstanceListQuery({
    variables: {
      tenantId
    },
    pause: !tenantId
  });

  const totalCount = data?.searchResult.totalCount ?? 0;

  return (
    <Content scrolling={true}>
      <div className="table-heading">
        <span className="metric">{totalCount}</span>
        <span className="title ml-5">
          {t("INSTANCE", { count: totalCount })}
        </span>
      </div>
      <InstanceList tenantId={tenantId} />
    </Content>
  );
};
